/* eslint no-param-reassign: "off" */

import { createSlice } from '@reduxjs/toolkit';
import { addPhrase, getPhrases, updatePhrase, removePhrase } from './phraseService';

export const phraseSlice = createSlice({
  name: 'phrase',
  initialState: {
    loading: 'idle',
    phrases: JSON.parse(localStorage.getItem('phrases')) || [],
    items: [],
    total: 0,
    options: {
      query: '',
      page: 1,
      total: 0,
      limit: 100,
    },
    filteredCategories: JSON.parse(localStorage.getItem('filter-categories')) || [],
    currentRequestId: undefined,
    error: null,
  },
  reducers: {
    setFilteredCategories: (state, action) => {
      localStorage.setItem('filter-categories', JSON.stringify(action.payload));
      state.filteredCategories = action.payload;
    },
    setOptions: (state, action) => {
      state.options = action.payload;
    },
  },
  extraReducers: {
    [addPhrase.pending]: (state, action) => {
      if (state.loading === 'idle') {
        state.loading = 'pending';
        state.currentRequestId = action.meta.requestId;
      }
    },
    [addPhrase.fulfilled]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loading === 'pending' && state.currentRequestId === requestId) {
        state.loading = 'idle';
        state.items.unshift(action.payload);
        state.currentRequestId = undefined;
      }
    },
    [addPhrase.rejected]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loading === 'pending' && state.currentRequestId === requestId) {
        state.loading = 'idle';
        state.error = action.error;
        state.currentRequestId = undefined;
      }
    },
    [getPhrases.pending]: (state, action) => {
      if (state.loading === 'idle') {
        state.loading = 'pending';
        state.currentRequestId = action.meta.requestId;
      }
    },
    [getPhrases.fulfilled]: (state, action) => {
      const {
        requestId,
        arg: { limit, page },
      } = action.meta;

      if (state.loading === 'pending' && state.currentRequestId === requestId) {
        state.loading = 'idle';
        state.phrases = action.payload;
        const totalPhrases = action.payload.filter((phrase) =>
          new RegExp(state.options.query, 'i').test(phrase.title),
        );
        state.items = totalPhrases.slice(limit * (page - 1), limit * page);
        state.options.totalPage = Math.ceil(totalPhrases.length / limit);
        state.currentRequestId = undefined;
      }
    },
    [getPhrases.rejected]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loading === 'pending' && state.currentRequestId === requestId) {
        state.loading = 'idle';
        state.error = action.error;
        state.currentRequestId = undefined;
      }
    },
    [updatePhrase.fulfilled]: (state, action) => {
      state.items = [action.meta.arg, ...state.items.filter((item) => item.id !== action.payload)];
      state.phrases = [
        action.meta.arg,
        ...state.phrases.filter((item) => item.id !== action.payload),
      ];
      localStorage.setItem('phrases', JSON.stringify(state.phrases));
    },
    [removePhrase.fulfilled]: (state, action) => {
      state.items = state.items.filter((item) => item.id !== action.payload.phraseId);
    },
  },
});

export const { setFilteredCategories, setOptions } = phraseSlice.actions;

export const selectPhrases = (state) => state.phrase.items;
export const selectAllPhrases = (state) => state.phrase.phrases;
export const selectOptions = (state) => state.phrase.options;
export const selectFilteredCategories = (state) => state.phrase.filteredCategories;

export default phraseSlice.reducer;
